export default "__VITE_ASSET__Cryt9_qp__"